"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var ngraph_graph_1 = __importDefault(require("ngraph.graph"));
var utils_1 = require("./utils");
var Grapher = function (features) {
    var graph = (0, ngraph_graph_1.default)();
    var hashedCoordinateArray = [];
    features.forEach(function (feature) {
        if (feature.geometry && feature.geometry.coordinates) {
            feature.geometry.coordinates.forEach(function (coord, index) {
                var _a;
                // Add to coordinates
                hashedCoordinateArray.push({
                    location: coord,
                    hash: (0, utils_1.getLocationHash)(coord),
                });
                // Create edges
                if (index > 0) {
                    if ((_a = feature.properties) === null || _a === void 0 ? void 0 : _a.desc_) {
                        graph.addLink((0, utils_1.getLocationHash)(feature.geometry.coordinates[index - 1]), (0, utils_1.getLocationHash)(feature.geometry.coordinates[index]), {
                            desc_: feature.properties.desc_,
                        });
                        graph.addLink((0, utils_1.getLocationHash)(feature.geometry.coordinates[index]), (0, utils_1.getLocationHash)(feature.geometry.coordinates[index - 1]), {
                            desc_: feature.properties.desc_,
                        });
                    }
                    else {
                        graph.addLink((0, utils_1.getLocationHash)(feature.geometry.coordinates[index - 1]), (0, utils_1.getLocationHash)(feature.geometry.coordinates[index]));
                        graph.addLink((0, utils_1.getLocationHash)(feature.geometry.coordinates[index]), (0, utils_1.getLocationHash)(feature.geometry.coordinates[index - 1]));
                    }
                }
            });
        }
    });
    var uniqueHashes = (0, uniqBy_1.default)(hashedCoordinateArray, "hash");
    // console.log(`Got ${uniqueHashes.length} unique coordinates.`);
    var vertices = [];
    // Add coords (unique hashes) to graph
    uniqueHashes.forEach(function (hash) {
        graph.addNode(hash.hash, { x: hash.location[0], y: hash.location[1] });
        vertices.push(hash.location);
    });
    return {
        graph: graph,
        vertices: vertices,
    };
};
var BuildGraph = function (network) {
    /**
     * An extended Graph is required to perform calculations when crossing the meridian
     */
    var mainGraph = Grapher(network.features);
    var positiveNetwork = (0, utils_1.alterFeatureCoordinates)(network, "LTR");
    var positiveGraph = Grapher(positiveNetwork.features);
    var negativeNetwork = (0, utils_1.alterFeatureCoordinates)(network, "RTL");
    var negativeGraph = Grapher(negativeNetwork.features);
    return {
        mainGraph: mainGraph,
        positiveGraph: positiveGraph,
        negativeGraph: negativeGraph,
    };
};
exports.default = BuildGraph;
